import { useState } from 'react';
import { Outlet } from 'react-router-dom';

import { useAuth } from '../../../context/AuthContext';
import UnsupportedBrowserBanner from '../../modals/UnsupportedBrowserBanner';
import { Footer } from '../Footer';
import { LoginModal } from '../LoginModal';
import { Navigation } from '../navigation';

const Layout = () => {
  const { signOut, session, screen_name } = useAuth();
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);

  const handleSignIn = () => {
    setIsLoginModalOpen(true);
  };

  console.log('screenName', screen_name, window.location);
  
  const isCallbackPage = window.location.pathname.includes('/callback');
  
  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <UnsupportedBrowserBanner />
      <Navigation 
        isLoggedIn={!!session} 
        handleSignIn={handleSignIn}
        handleSignOut={signOut}
        screen_name={screen_name}
      />
      <main style={{ flex: 1, background: '#FFF9F5' }}>
        <Outlet />
      </main>
      {!isCallbackPage && <Footer />}
      <LoginModal 
        isOpen={isLoginModalOpen}
        onClose={() => setIsLoginModalOpen(false)}
      />
    </div>
  );
};

export default Layout;